export function rebuildOrderedIdsForSubset<T>(
  allIds: readonly T[],
  previousSubset: readonly T[],
  reorderedSubset: readonly T[]
): T[] {
  const previousIds = new Set(previousSubset);
  let reorderedIndex = 0;
  return allIds.map((id) => (
    previousIds.has(id) ? reorderedSubset[reorderedIndex++] : id
  ));
}
